<template>
	<!-- banner -->
	<section class="car-final-section hero" style="background-image: url(/images/orcamento.jpg);">
		<div class="row d-flex" v-if="contato != ''">
			<div class="container">
				<div class="carrinho-final">
					<p v-html="contato[0].itiDescricao2"></p>
				</div>

			</div>
		</div>
	</section>
	<!-- END banner -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'


export default {
	name: 'CarrinhoFinalView',
	components: {

	},

	data: () => ({
		topoBanner: [],
		contato: [],
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Carrinho - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/40/topocarrinho/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});


		axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
			.then(response => {
				this.contato = response.data;
				//console.log('formulario contato')
				//console.log(this.contato)
			})
			.catch(error => {
				console.error(error);
			});

		let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
		if (dadosArmazenados) {
			dadosArmazenados = JSON.parse(dadosArmazenados);
			if (dadosArmazenados.produtos[0] != null) {
				dadosArmazenados.produtos = [];
				dadosArmazenados.agenda[0].Obs = '';
				localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados))
				this.$store.commit('updateVariavelHeader2', dadosArmazenados.produtos.length);
			}
		}

	},
}

</script>

<style scoped></style>
